import { ApolloCache, useQuery } from "@apollo/client";
import { graphql } from "~/gql";
import {
  FindMatterExclusions,
  FindMatterExclusionsVariables,
  FindMatterExclusions_matterExclusions,
} from "../types";
import { createExclusions_createExclusions } from "../__generated_types__/createExclusions";
import { updateExclusion_updateExclusion } from "../__generated_types__/updateExclusion";

export const MATTER_EXCLUSIONS_QUERY = graphql(/* GraphQL */ `
  query FindMatterExclusions($input: Float!) {
    matterExclusions(input: $input) {
      ...ExclusionFragment
    }
  }
`);

export function useMatterExclusionsQuery(matterId: number) {
  return useQuery<FindMatterExclusions, FindMatterExclusionsVariables>(MATTER_EXCLUSIONS_QUERY, {
    variables: { input: matterId },
  });
}

export function addToMatterExclusionsCache(
  cache: ApolloCache<any>,
  matterId: number,
  exclusions: createExclusions_createExclusions[]
) {
  updateMatterExclusionsCache(cache, matterId, (matterExclusions: any) => {
    return [...exclusions.map((e) => ({ ...e })), ...matterExclusions];
  });
}

export function replaceInMatterExclusionsCache(
  cache: ApolloCache<any>,
  matterId: number,
  exclusion: updateExclusion_updateExclusion
) {
  const { id } = exclusion;
  updateMatterExclusionsCache(cache, matterId, (matterExclusions: any) => {
    return matterExclusions.map((a: any) => (id === a.id ? exclusion : a));
  });
}

export function removeFromMatterExclusionsCache(
  cache: ApolloCache<any>,
  matterId: number,
  exclusionIds: number | number[]
) {
  const exclusionIdsToRemove = Array.isArray(exclusionIds) ? exclusionIds : [exclusionIds];
  updateMatterExclusionsCache(cache, matterId, (matterExclusions) => {
    return matterExclusions.filter((a) => exclusionIdsToRemove.find((id) => a.id !== id));
  });
}

function updateMatterExclusionsCache(
  cache: ApolloCache<any>,
  matterId: number,
  getNewMatterExclusions: (
    matterExclusions: FindMatterExclusions_matterExclusions[]
  ) => FindMatterExclusions_matterExclusions[]
) {
  try {
    const { matterExclusions } =
      cache.readQuery<FindMatterExclusions>({
        query: MATTER_EXCLUSIONS_QUERY,
        variables: { input: matterId },
      }) || {};

    if (matterExclusions) {
      const newMatterExclusions = getNewMatterExclusions(matterExclusions);
      cache.writeQuery<FindMatterExclusions>({
        query: MATTER_EXCLUSIONS_QUERY,
        variables: { input: matterId },
        data: {
          matterExclusions: newMatterExclusions,
        },
      });
    }
  } catch (ex) {
    console.error(ex); // TODO: Handle error
  }
}
